import { ContactFieldModel } from "../data";

export interface ContactFieldsPayloadModel {
  contactFieldPayloads: ContactFieldModel[];
}
